import { Typography } from 'fuse-ui';
import { withStyles } from '@material-ui/core';
import React from 'react';
import SelectMulti from 'pre-fuse/components/SelectMulti';

import PropTypes from 'prop-types';

const styles = theme => {
    return  {
        container: {
            '&:focus-within > span': {
                color: theme.palette.primary[900],
            }
        },
        label: {
            paddingBottom: theme.spacing.unit,
            paddingTop: theme.spacing.unit * 2,
        },
    };
};

const DomainMultiSelect = ( { classes, isDisabled, domains, selectedDomains, setSelectedDomains } ) => {

    let domainOptions = domains.map( ( domain ) => {
        return { label: domain, value: domain };
    } );

    const selectedDomainOptions = selectedDomains.map( ( domain ) => {
        return { label: domain, value: domain };
    } );

    const changeHandler = ( newSelection ) => {
        setSelectedDomains( newSelection.map( ( selection => selection.value ) ) );
    };

    return (
        <div className={classes.container}>
            <Typography variant="overline" className={classes.label}>Domains In This Group</Typography>
            <SelectMulti
                id="domain-multi-select"
                automationId="domain-multi-select"
                isDisabled={isDisabled}
                options={domainOptions}
                placeholder={'Select domains'}
                searchPlaceholder={'Type in to Search'}
                value={selectedDomainOptions}
                renderVirtual={true}
                onChange={changeHandler}
            />
        </div>
    );
};

DomainMultiSelect.propTypes = {
    classes: PropTypes.object.isRequired,
    domains: PropTypes.array.isRequired,
    isDisabled: PropTypes.bool,
    selectedDomains: PropTypes.array.isRequired,
    setSelectedDomains: PropTypes.func.isRequired
};

export default withStyles( styles )( DomainMultiSelect );
